// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-human-skills{margin-top:1em}.filter-human-skills .skill{border-radius:5px;background-color:#104182;margin:0.5em;padding:0.2em;color:#fff}.filter-human-skills .skill:hover{cursor:pointer}.filter-human-skills .skill.selected{background-color:#4b607e}\n", ""]);
// Exports
module.exports = exports;
